export const profileKeys = {
  all: ['profile'] as const,
} as const
